import { render, staticRenderFns } from "./RoleManagementDecentralized.vue?vue&type=template&id=e17b1982&"
import script from "@/scripts/modal/systemManager/roleManagement/roleManagementDecentralized.js?vue&type=script&lang=js&"
export * from "@/scripts/modal/systemManager/roleManagement/roleManagementDecentralized.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports